import(/* webpackMode: "eager" */ "/app/apps/web/src/app/(marketing)/industries/logistics/page.tsx");
